import { toRaw } from 'vue';

export function mergeEditData(seed: Record<string, any>, editData: any): Record<string, any> {
  if (!editData || typeof editData !== 'object') return seed;
  const result: Record<string, any> = {};
  for (const [key, value] of Object.entries(seed)) {
    if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
      result[key] = mergeEditData(value, editData);
    } else if (key in editData) {
      result[key] = toRaw(editData[key]);
    } else {
      result[key] = toRaw(value);
    }
  }
  return result;
}
